export enum QueryTypeOptions {
  Elastic = 'elastic',
  FasitDsl = 'fasitDsl'
}
